/**
 * @generated SignedSource<<df31d60c27af19f37593d9c26fceb25d>>
 * @relayHash be1c1fb8fb6d4391e28ce4c975d1938d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 5fe5f85261296a591308f2f6b2f5a124d20eae0cd54295e3c49f5fac3c4ffaf4

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { PRDetailsPopupViewUiQuery } from './PRDetailsPopupViewUiQuery.graphql';

const node: PreloadableConcreteRequest<PRDetailsPopupViewUiQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "5fe5f85261296a591308f2f6b2f5a124d20eae0cd54295e3c49f5fac3c4ffaf4",
    "metadata": {},
    "name": "PRDetailsPopupViewUiQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
